import { ROUTE_NAMES } from './routeNames.const'

export const routeBudget = {
  path: '/budget/:budgetId?',
  props: true,
  name: ROUTE_NAMES.budget,
  component: () =>
    import(/* webpackChunkName: "Budget" */ 'src/pages/Budget/Budget.vue'),
}
